import React from 'react';
import {useLocation} from 'react-router';

import {StrictLocaleLoaderRouter} from 'coreComponents/LoaderRouter';

/**
 * Splat route that hands every URL to the existing two-level router
 * (`brand/app/components/LoaderRouter/routes` → `APIRouter`), exactly as the PWA Kit
 * `routes.ts` catch-all did. Brand routes can move into `app/routes.ts` incrementally.
 */
const CatchAllRoute = () => {
	const location = useLocation();

	return <StrictLocaleLoaderRouter location={location} />;
};

export default CatchAllRoute;
